import React from 'react';

export default () => <div className="clearfix"/>;



// WEBPACK FOOTER //
// ./src/components/common/clearfix.jsx